import { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import About from './About';
import './App.css';
import Admin from './components/Admin';
import Footer from './components/Footer';
import Header from './components/Header';
import { auth } from './Firebase/config';
import Home from './Home';
function App() {

  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
